$(document).ready(function(){
    
    
    var $mov = $(".p-mv__movie");
    document.querySelector('.p-mv__movie video').controls = false;
    //$mov.find("video").get(0).play();

    $('.p-mv__movie-close').click(function(){
      document.querySelector('.p-mv__movie video').controls = false;
      $mov.find("video").get(0).pause();
      $mov.find("video").get(0).load();
      $(this).css("display", "none");
      $(this).parents().find('.p-mv .p-mv__movie-btn .p-mv__movie-play-btn-icon').css('display', 'block');
      $(this).parents().find('.p-mv').removeClass('video-popup');
    });
    $('.p-mv__movie-play-btn').click(function(){
      	document.querySelector('.p-mv__movie video').controls = true;
        $(this).parents().find('.p-mv .p-mv__movie .p-mv__movie-close').css("display", "block");
      	$(this).parents().find('.p-mv').addClass('video-popup');
        $mov.fadeIn(600, "easeOutCubic", function () {
        $mov.find("video").get(0).load();
        $mov.find("video").get(0).play();
        $(this).parents().find('.p-mv .p-mv__movie-btn .p-mv__movie-play-btn-icon').css("display", "none");
        $(this).parents().find('.p-mv .p-mv__movie').css("display", "block");
      });
    });
    const mov_video = document.querySelector('.p-mv__movie video');
    mov_video.addEventListener('ended', (event) => {
//       $mov.hide();
    });
  	
  	
    const video = document.querySelector('.p-watch-movie__mov video');
    if(video){
      video.addEventListener('ended', (event) => {
        $(".p-watch-movie__mov").hide();
      });
    }
  
  });

jQuery(window).scroll(function(){
    if(jQuery(window).width() > 991){
      var scrollTop = jQuery(this).scrollTop();
      var pageOffset = jQuery(document).height();
      var footerOffset = jQuery(".explore-balmuda").offset().top;	
      var leftOffset = jQuery('.custom_pdp_grid .text-center').offset().top;
      var sliderWidth = jQuery('.pdp-left-section').width();
      var sliderHeight = jQuery('.product-single__photos').height();
      var thumbnailHeight = jQuery('.product-single__photos .product-images .thumb-nav').height();
      
      var issliderNotZoomed = $('.restore-zoom-icon:visible').length;
      if(issliderNotZoomed){
        jQuery('.pdp-left-section .product-single__photos').css('width', 'auto');
      }else{
        if(scrollTop > leftOffset){
          if( ( pageOffset - footerOffset ) < ( scrollTop - sliderHeight - thumbnailHeight ) ){
          }else{
            jQuery('.pdp-left-section .product-single__photos').css('width', sliderWidth);
              jQuery(document).find('.pdp-left-section').addClass('fixed-slider');
          }
        } else{
          jQuery('.pdp-left-section .product-single__photos').css('width', 'auto');
          jQuery(document).find('.pdp-left-section').removeClass('fixed-slider');
        }
      }
    }
  })


var videoPlayer = document.getElementById("videoPlayer");
  var myVideo = document.getElementById("myVideo");
  
  function stopVideo(){
    this.play?this.pause():this.play();
    videoPlayer.style.display = "none";
  }

  function playVideo(file) {
    //this.paused?this.play():this.pause();
    myVideo.src = file;
    videoPlayer.style.display = "block";
  }

$(window).on('load', function() {
    
    var check = setInterval(function() {

      let sprCheck = $('.spr-form:visible').length;

      var spr = $("#shopify-product-reviews"),
          container = spr.find(".spr-content"),
          reviewButton = spr.find(".spr-summary-actions-newreview");

      if (sprCheck) {
// 		$('html').css('overflow-y', 'hidden');
        // Checking msg
       	let sprMsg = $('.spr-form .new-review-form .spr-form-message').length;
        if(sprMsg){
          
          	spr.find(".spr-content .spr-form form.new-review-form .close-review-form").css("display", "none");
        	spr.find(".spr-content .spr-form form.new-review-form").append( "<span class='close-popup-btn close-review-msg-form'></span>" );
          clearInterval(check);
        }else{
        	
        }

      }else{
        if($( "form.new-review-form span" ).hasClass('close-review-form')){
      		// nothing here
        }else{
          
        	spr.find(".spr-content .spr-form form.new-review-form").append( "<span class='close-popup-btn close-review-form'></span>" );
          	//spr.find(".spr-content .spr-form form.new-review-form .spr-form-actions").append("<span class='btn close_btn close-review-form'>CANCEL</span>");
          
        }
      }
    }, 300);
 
    
    var checkReviews = setInterval(function() {

      let sprCheckReviews = $('.spr-content .spr-reviews:visible').length; 

      var spr = $("#shopify-product-reviews"),
          container = spr.find(".spr-content"),
          reviewButtonFeeds = spr.find(".spr-summary-actions-togglereviews");

      if (sprCheckReviews) {
        
        let checkCloseFeed =  $('.spr-reviews .close-review-feeds').length;
        
        if(checkCloseFeed){ 
        	//clearInterval(checkReviews); 
        }else{
//           	$('html').css('overflow-y', 'hidden');
        	spr.find(".spr-content .spr-reviews").append( "<span class='close-popup-btn close-review-feeds'></span>" );
        }
      }else{
        
      }
    }, 300);
    
    
    var check_summary = setInterval(function() {
      let spr = window['SPR'];
      
      if(spr){
        
        var header = '';
        var content = '';
        var final_reviews = '<div class="spr-reviews">';
        $('.spr-content .spr-reviews .spr-review').each(function(i, obj) {
          header = $(this).find('.spr-review-header').html();
          content = $(this).find('.spr-review-content').html();

          final_reviews = final_reviews + '<div class="spr-review">'+header+content+'</div>';
        });
        
        final_reviews = final_reviews + '</div>';

        $('.spr-summary').prepend(final_reviews);
        
        clearInterval(check_summary);
      }else{
      
      }

    }, 4000);
    
  });
  
  
  
  $(document).on('click', '.spr-form .new-review-form .close-review-form', function(){
//     $('html').css('overflow-y', 'auto');
    $(this).parents().find('.spr-form').css("display", "none");
  });
  
  $(document).on('click', '.spr-form .new-review-form .close-review-msg-form', function(){
//     $('html').css('overflow-y', 'auto');
    location.reload();
  });
  
  
  $(document).on('click', '.spr-reviews .close-review-feeds', function(){
//     $('html').css('overflow-y', 'auto');
    $(this).parents().find('.spr-reviews').css("display", "none");
    $('.spr-summary .spr-reviews').css('display', 'block');
  });
